import React, { useState, useEffect } from 'react';
import './StudentDashboard.css';
import {
  Container,
  Typography,
  Box,
  Button,
  AppBar,
  Toolbar
} from '@mui/material';
import { Logout } from '@mui/icons-material';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import buddyMascot from '../assets/freepik__the-pant-color-should-be-light-yellow__49787 (1) (1).png';

const StudentDashboard = () => {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  console.log('[StudentDashboard] render', {
    loading,
    hasStudent: !!student,
    search: location.search
  });

  useEffect(() => {
    console.log('[StudentDashboard] auth effect start');
    const token = localStorage.getItem('studentToken');
    console.log('[StudentDashboard] token present:', !!token);

    if (!token) {
      console.warn('[StudentDashboard] no token found, redirecting to /student/login');
      navigate('/student/login');
      return;
    }

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    // Try to get student info from URL query parameters first
    const queryParams = new URLSearchParams(location.search);
    const studentFromQuery = {
      id: queryParams.get('id'),
      prn: queryParams.get('prn'),
      name: queryParams.get('name'),
      email: queryParams.get('email'),
      phone: queryParams.get('phone'),
      course: { name: queryParams.get('course') },
      session_id: queryParams.get('session_id')
    };

    console.log('[StudentDashboard] query params extracted', {
      id: studentFromQuery.id,
      prn: studentFromQuery.prn,
      name: studentFromQuery.name,
      email: studentFromQuery.email,
      phone: studentFromQuery.phone,
      course: studentFromQuery.course?.name,
      session_id: queryParams.get('session_id')
    });

    // Check if we have complete student info from query params
    if (studentFromQuery.id && studentFromQuery.prn && studentFromQuery.name) {
      console.log('[StudentDashboard] using student data from query params');
      setStudent(studentFromQuery);
      setLoading(false);
      return;
    }

    // Fallback: decode the token to get basic student info
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      console.log('[StudentDashboard] token payload decoded', payload);

      setStudent({
        id: payload.id,
        prn: payload.prn,
        name: payload.name,
        email: '', // Not in token
        phone: '',
        course: { name: '' }
      });
    } catch (error) {
      console.error('[StudentDashboard] token decode failed', error);
      setStudent(null);
    } finally {
      setLoading(false);
    }
  }, [navigate, location.search]);



  useEffect(() => {
    console.log('[StudentDashboard] bot effect start', {
      loading,
      student,
      search: location.search
    });

    if (loading) return;

    const existing = document.getElementById("geta-bot-script");
    if (existing) {
      console.log('[StudentDashboard] bot script already present, skipping append');
      return; // Prevent loading twice
    }

    const queryParams = new URLSearchParams(location.search);
    const sessionId = student?.session_id || queryParams.get('session_id') || 'default_session';
    console.log('[StudentDashboard] session id resolution', {
      studentSessionId: student?.session_id,
      querySessionId: queryParams.get('session_id'),
      finalSessionId: sessionId
    });

    let session_id  = sessionId.toString();
    console.log('[StudentDashboard] session_id passed to GetA', session_id);

    const script = document.createElement("script");
    script.id = "geta-bot-script";
    script.async = true;
    script.src = "https://bot-frame.geta.ai/output.js";

    script.onload = () => {
      console.log('[StudentDashboard] bot script loaded');
      if (window.GetA) {
        console.log('[StudentDashboard] window.GetA found, invoking bot');
        window.GetA(
          "WXA3WHNmSFFnRGRXcWpvSDpiOGZkMGI0NTBjZDZiMDZjYWYwYTU2MGMzYTJlOWEwNmNiZmRiNWJlZWJmMzI5N2I0MmMwMDNiOGMyMzg2MzVi",
          920,
          'c36c2605-6e79-47b2-b22e-1ea5b6381b84',
          false,
          "geta.ai",
          "geta_bot",
          true,
          session_id
        );
      } else {
        console.error('[StudentDashboard] window.GetA missing after script load');
      }
    };

    script.onerror = (error) => {
      console.error('[StudentDashboard] failed to load bot script', error);
    };

    document.body.appendChild(script);
    console.log('[StudentDashboard] bot script appended to document body');

    return () => {
      console.log('[StudentDashboard] cleanup bot script');
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [loading, student, location.search]);

  const handleLogout = () => {
    localStorage.removeItem('studentToken');
    delete axios.defaults.headers.common['Authorization'];
    navigate('/');
  };

  if (loading) {
    return (
      <Container>
        <Typography>Loading...</Typography>
      </Container>
    );
  }

  if (!student) {
    return (
      <Container>
        <Typography>Student not found</Typography>
      </Container>
    );
  }

  return (
    <Box sx={{ width: '100vw', height: '100vh', margin: 0, padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      {/* Header Section */}
      <AppBar position="static" sx={{ zIndex: 1100, backgroundColor: '#c52f33' }}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Student Dashboard - AI Student Support Assistant
          </Typography>
          <Button color="inherit" onClick={handleLogout} startIcon={<Logout />}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      <Box>
         <section className="landing_page_content">
          <div className="client_data">
              <div className="client_data_box">
                  <div className="first_wrap" style={{ textAlign: 'center' }}>
                      {/* Buddy Mascot */}
                      <div style={{ marginBottom: '20px' }}>
                          <img 
                            src={buddyMascot}
                            alt="SSODL Buddy Mascot" 
                            style={{ height: '120px', display: 'block', margin: '0 auto' }}
                          />
                      </div>
                      <div className="client_logo">
                          <img className="g_client_img" src="https://assets.getalabs.com/assets/icons/ssodl_logo.png" alt="Client Logo" style={{ display: 'block' }} />
                      </div>
                      <div className="heading_wrapper">
                          <div className="heading_text" style={{ textAlign: 'center' }}>  
                              <h1 style={{ color: '#c52f33' }}>Buddy</h1>
                          </div>
                          <div className="subtext" style={{ textAlign: 'center' }}>
                              <p>Your new digital companion is here to make your SSODL journey smoother.</p>
                          </div>
                      </div>
                  </div>
                  <div className="button_wrap">
                      <div className="g_landing_page_button" style={{display: 'none'}}>
                          <span className="g_btn_link" aria-hidden="true"></span>
                      </div>
                  </div>
              </div>
          </div>
          <div className="bot_area">
            <div id="geta_bot">

            </div>
          </div>
      </section>
      </Box>
    </Box>
  );
};

export default StudentDashboard;
